import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "./redux/loginSlice";
import financialarapSlice from "./redux/financialarapSlice";
import userManagementSlice from "./redux/userManagementSlice";
import xerowritebackSlice from "./redux/xerowritebackSlice";
import userSalesLeadPersonSlice from "./redux/userSalesLeadPersonSlice";
import bannerNotificationSlice from "./redux/bannerNotificationSlice";
import dashboardSlice from "./redux/dashboardSlice";
import referraPartnerSlice from "./redux/referraPartnerSlice";
import userReportsSlice from "./redux/userReportsSlice";
import pricingplanSlice from "./redux/pricingplanSlice";
import salesLeadSlice from "./redux/salesLeadSlice";
import roleManagementSlice from "./redux/roleManagementSlice";
import activityLogSlice from "./redux/activityLogSlice";
import accountingSoftwareSlice from "./redux/accountingSoftwareSlice";
import emailTemplateLogSlice from "./redux/emailTemplate.slice";
import smsTemplateLogSlice from "./redux/smsTemplateSlice";
import userActivityLogSlice from "./redux/userActivityLogSlice";
import invoiceDetailsSlice from "./redux/invoiceDetailsSlice";
import ownerTabSlice from "./redux/ownerTabSlice";
import platformPartnerAppSlice from "./redux/platformPartnerAppSlice";
import promocodeSlice from "./redux/promocodeSlice";
import fundedAmountSlice from "./redux/updateFundedAmountSlice";
import loanLessHundreadSlice from "./redux/loanLessHundreadSlice";
import clientDetailsTabSlice from "./redux/clientDetailsTabSlice";
import invoiceSlice from "./redux/invoiceSlice";
import authSlice from "./redux/authSlice";
import commentSlice from "./redux/commentSlice";
import datePickerSlice from "./redux/datePickerSlice";
import agreementPagesSlice from "./redux/agreementPagesSlice";
import trustCorporateTabSlice from "./redux/trustCorporateTabSlice";
import logger from "redux-logger";
import onboardingSlice from "./redux/onboardingSlice";

const store = configureStore({
  reducer: {
    login: loginSlice,
    auth: authSlice,
    financialarap: financialarapSlice,
    userManagement: userManagementSlice,
    clientDetails: clientDetailsTabSlice,
    adminXeroWriteBack: xerowritebackSlice,
    userSalseLeadPerson: userSalesLeadPersonSlice,
    bannerNotification: bannerNotificationSlice,
    dashboardTable: dashboardSlice,
    referralPartner: referraPartnerSlice,
    userReport: userReportsSlice,
    pricingPlan: pricingplanSlice,
    salesLead: salesLeadSlice,
    roleManagement: roleManagementSlice,
    activityLogManagement: activityLogSlice,
    accountingSoftware: accountingSoftwareSlice,
    emailTemplateLogs: emailTemplateLogSlice,
    smsTemplateLogs: smsTemplateLogSlice,
    userActivityLog: userActivityLogSlice,
    invoiceDetails: invoiceDetailsSlice,
    ownerTab: ownerTabSlice,
    platformPartnerApp: platformPartnerAppSlice,
    promoCodeApp: promocodeSlice,
    fundedAmount: fundedAmountSlice,
    loanLessHundred: loanLessHundreadSlice,
    invoice: invoiceSlice,
    comment: commentSlice,
    datepicker: datePickerSlice,
    agreementPages: agreementPagesSlice,
    onboarding: onboardingSlice,
    trustCorporateTab: trustCorporateTabSlice
  },
  middleware: (getDefaultMiddleware) =>
    process.env.NODE_ENV !== "production"
      ? getDefaultMiddleware({ serializableCheck: false }).concat(logger)
      : getDefaultMiddleware({ serializableCheck: false })
});

export default store;
